import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk';
import { environment } from '../../environments/environment';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class AwsApiService {
  private cognitoApi: AWS.CognitoIdentityServiceProvider;

  constructor(private log: LogService) {
    AWS.config.update({ region: environment.aws.region });
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.aws.identityPoolId
    });

    this.log.trace('AwsApiService.New', {
      identityPool: environment.aws.identityPoolId
    });
    this.cognitoApi = new AWS.CognitoIdentityServiceProvider();
  }

  cognito() {
    return this.cognitoApi;
  }
}
